import React from 'react'
import styles from './LbPricing.module.css'
import { motion } from 'framer-motion'
import { FaCheckCircle } from 'react-icons/fa'

const plans = [
    {
        title: 'Starter',
        price: '₹0 / mo',
        note: 'Included in CRM',
        features: [
            '1 Domain Integration',
            'Basic Analytics',
            'Real-Time CRM Sync',
            'Unlimited Leads',
        ],
        highlight: false,
    },
    {
        title: 'Pro',
        price: '₹499 / mo',
        note: '',
        features: [
            'Up to 5 Domains',
            'Smart Lead Routing',
            'Advanced Analytics',
            'Priority Email Support',
        ],
        highlight: true,
    },
    {
        title: 'Enterprise',
        price: 'Contact Us',
        note: '',
        features: [
            'Unlimited Forms & Domains',
            'Custom API Integrations',
            'Dedicated Success Manager',
            'SLA & 24x7 Support',
        ],
        highlight: false,
    },
]

const LbPricing = () => {
    return (
        <section className={styles.pricingSection}>
            <div className={styles.container}>
                <motion.h2
                    className={styles.heading}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    Pricing Plans for Every Stage
                </motion.h2>
                <motion.p
                    className={styles.subheading}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                >
                    Whether you're just starting or scaling across regions, LeadBridge™ has a plan for you.
                </motion.p>

                <div className={styles.cardsWrapper}>
                    {plans.map((plan, index) => (
                        <motion.div
                            key={index}
                            className={`${styles.card} ${plan.highlight ? styles.highlight : ''}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3 + index * 0.2, duration: 0.5 }}
                        >
                            <h3 className={styles.title}>{plan.title}</h3>
                            <p className={styles.price}>{plan.price}</p>
                            {plan.note && <p className={styles.note}>{plan.note}</p>}
                            <ul className={styles.featureList}>
                                {plan.features.map((feature, i) => (
                                    <li key={i}>
                                        <FaCheckCircle className={styles.icon} /> {feature}
                                    </li>
                                ))}
                            </ul>
                            <button className={styles.cta}>
                                {plan.price === 'Contact Us' ? 'Talk to Sales' : 'Get Started'}
                            </button>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default LbPricing
